import { useEffect, useState } from "react";
import { api, formatAmount } from "@/lib/api";
import { Trophy, TrendingUp, Zap, Flag } from "lucide-react";
import RacePanel from "@/components/RacePanel";

const TABS = [
  { key: "race", label: "Weekly Race", icon: Flag },
  { key: "profit", label: "Top Profit", icon: Trophy },
  { key: "volume", label: "Top Volume", icon: TrendingUp },
  { key: "wins", label: "Most Wins", icon: Zap },
];

export default function Leaderboard() {
  const [tab, setTab] = useState("race");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (tab === "race") return;
    api.get(`/leaderboard?by=${tab}`).then(({ data }) => setRows(data));
  }, [tab]);

  return (
    <div className="flex flex-col gap-6 fade-up">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-black tracking-tighter">Leaderboard</h1>
        <div className="text-zinc-500 text-sm mt-1">Where the vault keeps score.</div>
      </div>

      <div className="flex items-center gap-1 p-1 panel self-start max-w-full overflow-x-auto no-scrollbar">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            data-testid={`lb-tab-${key}`}
            className={`text-xs uppercase tracking-wider py-2 px-4 rounded-lg flex items-center gap-2 ${
              tab === key ? "bg-white/[0.08] text-amber-400" : "text-zinc-500 hover:text-white"
            }`}
          >
            <Icon size={13} /> {label}
          </button>
        ))}
      </div>

      {tab === "race" ? <RacePanel /> : (
      <div className="panel overflow-hidden">
        <table className="data-table" data-testid="leaderboard-table">
          <thead>
            <tr>
              <th style={{ width: 60 }}>#</th>
              <th>Player</th>
              <th>Bets</th>
              <th>Wins</th>
              <th>Volume</th>
              <th>Profit</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={6} className="text-zinc-600 text-center py-12">No action yet. Be the first.</td></tr>
            ) : (
              rows.map((r, i) => (
                <tr key={r.user_id}>
                  <td className="font-mono-num font-bold text-amber-400">#{i + 1}</td>
                  <td>
                    <div className="flex items-center gap-2">
                      <div className="w-7 h-7 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center text-xs font-bold text-black">
                        {(r.username || "?").slice(0, 1).toUpperCase()}
                      </div>
                      {r.username}
                    </div>
                  </td>
                  <td className="font-mono-num">{r.bets}</td>
                  <td className="font-mono-num text-emerald-400">{r.wins}</td>
                  <td className="font-mono-num">{formatAmount(r.volume, "FMI")}</td>
                  <td className={`font-mono-num font-semibold ${r.profit >= 0 ? "text-emerald-400" : "text-rose-400"}`}>
                    {r.profit > 0 ? "+" : ""}{formatAmount(r.profit, "FMI")}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      )}
    </div>
  );
}
